var _circle, _path, _path2, _g, _rect, _path3, _path4, _rect2, _circle2, _circle3, _ellipse, _ellipse2, _g2, _rect3, _rect4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderAvatar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10426_74671)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10426_74671)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0001,
    cy: 7.71418,
    r: 4.28571,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.24619 19.6288C4.04282 18.7225 3.93225 16.9774 5.04063 15.9571C6.83618 14.3042 9.29195 13.2856 12.0001 13.2856C14.7083 13.2856 17.1641 14.3042 18.9596 15.9571C20.068 16.9774 19.9575 18.7225 18.7541 19.6288C16.9025 21.0233 14.5546 21.8571 12.0001 21.8571C9.44565 21.8571 7.09778 21.0233 5.24619 19.6288Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10426_74671",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 13,
    width: 16,
    height: 9
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24619 19.6288C4.04282 18.7225 3.93225 16.9774 5.04063 15.9571C6.83618 14.3042 9.29195 13.2856 12.0001 13.2856C14.7083 13.2856 17.1641 14.3042 18.9596 15.9571C20.068 16.9774 19.9575 18.7225 18.7541 19.6288C16.9025 21.0233 14.5546 21.8571 12.0001 21.8571C9.44565 21.8571 7.09778 21.0233 5.24619 19.6288Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10426_74671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.9375 12.375H17.0625L18 22.5H6L6.9375 12.375Z",
    fill: "#252727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 18.1875L7.125 14.0625L12 12.75L16.875 14.0625L12 18.1875Z",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16.3125L7.125 12.1875L12 10.875L16.875 12.1875L12 16.3125Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_10426_74671)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FAD228"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3684 12.1865C8.44134 12.5543 9.39583 13.512 9.39583 13.512C9.39583 13.512 8.21887 14.1125 7.63221 13.082C7.04556 12.0514 8.29546 11.8187 8.3684 12.1865Z",
    fill: "#1A1A1A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6633 12.1865C15.5904 12.5543 14.6359 13.512 14.6359 13.512C14.6359 13.512 15.8129 14.1125 16.3995 13.082C16.9862 12.0514 15.7363 11.8187 15.6633 12.1865Z",
    fill: "#1A1A1A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.75,
    y: 15,
    width: 4.5,
    height: 3,
    fill: "#FFB293"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.625,
    cy: 7.875,
    r: 2.625,
    fill: "#1A1A1A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.375,
    cy: 7.875,
    r: 2.625,
    fill: "#1A1A1A"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 30,
    rx: 17.25,
    ry: 12.75,
    fill: "#333333"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_10426_74671",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -6,
    y: 17,
    width: 36,
    height: 26
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 30,
    rx: 17.25,
    ry: 12.75,
    fill: "#03AAC7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_10426_74671)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 16.875,
    rx: 4.5,
    ry: 4.125,
    fill: "#FFB293"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.75,
    y: 9.75,
    width: 10.5,
    height: 3,
    rx: 1.5,
    fill: "#E8AF98"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.25,
    y: 4.5,
    width: 7.5,
    height: 11.25,
    rx: 3.75,
    fill: "#FFCAB4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 6.2C7.5 4.43269 8.835 3 10.4818 3H13.9455C15.3865 3 16.5 4.2536 16.5 5.8C16.5 7.3464 15.3865 9 13.9455 9H7.5V6.2Z",
    fill: "#1A1A1A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8372 5.625C16.2122 5.625 17.3372 4.875 17.3372 4.875C17.3372 4.875 17.6974 6.1463 16.5724 6.5213C15.4474 6.8963 15.4622 5.625 15.8372 5.625Z",
    fill: "#1A1A1A"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10426_74671"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10426_74671"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 11.25,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_10426_74671"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderAvatar);
export default __webpack_public_path__ + "static/media/header_avatar.286222c3596835d42f78b9124cfbf5d0.svg";
export { ForwardRef as ReactComponent };